import React, { PropsWithChildren } from 'react';
import { useSuspenseQuery } from '@tanstack/react-query';
import { fetchUser, loginRedirect, logoutRedirect } from './AuthApi/authApi';
import { authFetch } from 'auth/utils';
import { envVariables } from 'src/common/utils/envVariables';
import { AuthContext } from 'src/auth/AuthContext';

export const AuthProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const { data } = useSuspenseQuery({ queryKey: ['user'], queryFn: () => fetchUser() });

  useSuspenseQuery({
    queryKey: ['refresh-user-data'],
    queryFn: async () => {
      if (!globalThis.location.href.includes('provisioning-requests')) {
        await authFetch(`${envVariables.VITE_SIM_INVENTORY_USER_API}/me`);
      }

      return null;
    },
  });

  return data ? (
    <AuthContext.Provider
      value={{
        user: data,
        login: loginRedirect,
        logout: logoutRedirect,
      }}
    >
      {children}
    </AuthContext.Provider>
  ) : null;
};
